import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import moment from "moment"
import React, { Component } from 'react'
import { FormattedMessage } from 'react-intl'
import { Link, Redirect } from 'react-router-dom'
import EventBus from '../common/EventBus.js'
import GlobalHelper from "../common/GlobalHelper.jsx"
import ActionButton from "../common/button/actionbutton.component.jsx"
import SendEmailModal from "../common/email/sendemail.component.jsx"
import Icon from "../common/icon/icon.component.jsx"
import SideBar from "../common/layout/sidebar.component.jsx"
import ProposalPreviewModal from "../common/proposal/previewmodal.component.jsx"
import LoadingSpinner from '../common/spinner/loading.component.jsx'
import CreditLimitProtectionButton from "../invoice/CreditLimitProtectionButton"
import InvoiceHelper from '../invoice/invoicehelper.jsx'
import { EMAIL_TEMPLATE } from "../state/template/TemplateType"
import ProposalContent from "./content.component.jsx"
const queryString = require('query-string')

class ProposalPreview extends Component {

    constructor(props, context) {
        super(props, context)

        let todayDate = moment().toDate()
        todayDate.setHours(0, 0, 0, 0)
        todayDate = moment(todayDate.toISOString()).format('YYYY-MM-DD')

        let creditMemoFromQuoteExists = false
        if (this.props.location && this.props.location.state && this.props.location.state.creditMemoFromQuoteExists) {
            creditMemoFromQuoteExists = this.props.location.state.creditMemoFromQuoteExists
        }

        let owingBalance = this.props.location?.state?.owingBalance || 0.0
        let invoiceBalance = this.props.location?.state?.invoiceBalance || 0.0
        let creditLimit = this.props.location?.state?.creditLimit || 0.0
        let invoiceCurrency = this.props.location?.state?.invoiceCurrency || ""
        let fromEditAccountStatement = this.props.location?.state?.fromEditAccountStatement || false

        this.state = {
            proposal: null,
            proposalPrintUrl: '',
            hash: this.props.match.params.hash || '',
            documentId: '',
            invoiceId: '',
            orderId: '',
            loading: false,
            moreLoading: false,
            templateLoading: false,
            templateId: '',
            templateEmail: '',
            templates: [],
            sections: [],
            redirect: '',
            type: 'quote',
            status: '',
            editMode: false,
            modal: '',
            showToolbar: false,
            invoiceEmailTemplate: null,
            priceListEmailTemplate: null,
            orderEmailTemplate: null,
            todayDate,
            mobile: false,
            creditMemoFromQuoteExists,
            owingBalance,
            invoiceBalance,
            creditLimit,
            invoiceCurrency,
            fromEditAccountStatement,
        }
        this.handleItemOptionsChange = this.handleItemOptionsChange.bind(this)
        this.sendProposal = this.sendProposal.bind(this)
        this.handleCloseModal = this.handleCloseModal.bind(this)
        this.openSendEmail = this.openSendEmail.bind(this)
        this.openPreview = this.openPreview.bind(this)
        this.toggleToolbar = this.toggleToolbar.bind(this)
        this.refreshProposal = this.refreshProposal.bind(this)
        this.markAsSent = this.markAsSent.bind(this)
        this.configureRecurringEmail = this.configureRecurringEmail.bind(this)
        this.saveRecurringEmail = this.saveRecurringEmail.bind(this)
        this.markAsActive = this.markAsActive.bind(this)
        this.markAsInactive = this.markAsInactive.bind(this)
        this.printPdf = this.printPdf.bind(this)
        this.stopLoading = this.stopLoading.bind(this)
        this.saveEmailAndActivate = this.saveEmailAndActivate.bind(this)
        this.activatePriceList = this.activatePriceList.bind(this)
        EventBus.listen(EventBus.TopicPricingTableItemOptionsChanged, 'proposal-preview', this.handleItemOptionsChange)
    }

    componentDidMount() {
        this.refreshProposal(() => {
            SideBar.activateMenu(this.state.type)
            AppContext.getApiClient().get('/documents/templates/' + this.state.type + '-template').then(res => {
                this.setState({
                    templates: res.data.filter(t => t.attributes.status === "enabled" || t.attributes.status === "default")
                })
            })
        })
        AppContext.getApiClient().get('/templates/' + EMAIL_TEMPLATE.TYPE_EMAIL_INVOICE + '/template').then(t => {
            this.setState({
                invoiceEmailTemplate: t,
            })
        })
        AppContext.getApiClient().get('/templates/' + EMAIL_TEMPLATE.TYPE_EMAIL_PRICE_LIST + '/template').then(t => {
            this.setState({
                priceListEmailTemplate: t,
            })
        })
        AppContext.getApiClient().get('/templates/' + EMAIL_TEMPLATE.TYPE_EMAIL_ORDER + '/template').then(t => {
            this.setState({
                orderEmailTemplate: t,
            })
        })
        const uri = queryString.parse(this.props.location.search)
        this.setState({
            editMode: uri.em === '1',
        })

    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            creditMemoFromQuoteExists: nextProps.creditMemoFromQuoteExists || false,
        })
    }

    refreshProposal(callback) {
        AppContext.getApiClient().get('/proposals/' + this.state.hash).then(res => {
            this.setState({
                proposalPrintUrl: res.attributes.printUrl,
                proposal: res.attributes.variables,
                status: res.attributes.variables.quote.status,
                type: res.attributes.variables.document.type,
                documentId: res.attributes.documentId,
                invoiceId: res.attributes.invoiceId,
                orderId: res.attributes.orderId,
                sections: res.attributes.variables.sections,
                templateId: res.attributes.templateId,
                templateEmail: res.attributes.emailTemplate ? res.attributes.emailTemplate.attributes.defaultFromEmail : '',
            }, callback)
        })
    }

    handleItemOptionsChange(event) {
        AppContext.getApiClient().patch('/proposals/' + this.state.hash, {
            itemOptions: event.getData().itemOptions,
        }).then(res => { })
    }

    getRedirectUrl() {

        switch (this.state.type) {
            case 'quote':
            case 'contract':
                return '/quotes/' + this.state.proposal.quote.id + '/edit'
            case 'packing-slip':
                if (this.state.orderId != "") {
                    return '/orders/' + this.state.proposal.quote.id + '/edit'
                }
                if (this.state.invoiceId != "") {
                    return '/invoices/' + this.state.proposal.quote.id + '/edit'
                }
            case 'price-list':
                return '/price-lists/' + this.state.proposal.quote.id + '/edit'
            case 'order':
                return '/orders/' + this.state.proposal.quote.id + '/edit'
            case 'account-statement':
                if (this.state.fromEditAccountStatement) {
                    return '/account-statements/' + this.state.proposal.accountStatementId + '/edit'
                }
                return '/contacts/' + this.state.proposal.customer.contactId + '/details'
            case 'scheduling-page':
                return '/scheduling-pages/' + this.state.proposal.schedulingPage.id + '/edit'
            default:
                return '/' + this.state.type + 's/' + this.state.proposal.quote.id + '/edit'
        }
    }

    sendProposal(subject, toEmail, ccEmail, content, buttonLabel, pdfIncluded, templateKey, fromEmail, bccEmail, fromName) {
        window.scrollTo(0, 0)
        this.setState({ loading: true })
        AppContext.getApiClient().post('/proposals/' + this.state.hash + '/send-by-email', {
            subject: subject,
            toEmail: toEmail,
            ccEmail: ccEmail,
            content: content,
            fromName: fromName,
            buttonLabel: buttonLabel,
            attachments: pdfIncluded ?
                [
                    {
                        name: this.state.proposal.document.reference.concat(".pdf"),
                        fileLink: this.state.proposal.document.pdfUri,
                        contentType: "application/pdf",
                    }
                ] : [],
            fromEmail: fromEmail,
            bccEmail: bccEmail,
        })
            .then(res => {
                if (res.id) {
                    const isOnBoarding = AppContext.getAccount().attributes.onBoardingStatus === "pending"
                    if (this.state.type === 'quote') {
                        EventBus.dispatch(EventBus.TopicQuoteSent, {
                            proposal: res,
                        })
                    }
                    //update onboarding status if needed to ensure it's up to date right away
                    if (isOnBoarding) {
                        let updatedAccount = AppContext.getAccount()
                        updatedAccount.attributes.onBoardingStatus = "completed"
                        AppContext.setAccount(updatedAccount)
                        window.location = '/congrats'
                    } else {
                        this.setState({
                            loading: false,
                            redirect: <Redirect
                                to={{
                                    pathname: this.getRedirectUrl(),
                                    state: { showReceivePaymentModal: this.state.creditMemoFromQuoteExists }
                                }}
                            />
                        })
                    }
                } else {
                    this.setState({
                        loading: false,
                        redirect: <Redirect
                            to={{
                                pathname: this.getRedirectUrl(),
                                state: { showReceivePaymentModal: this.state.creditMemoFromQuoteExists }
                            }}
                        />
                    })
                }
            })
    }

    nextDueDateIsToday() {
        const recurringInfo = this.state.proposal.quote.recurringInfo.attributes
        const nextDueDate = moment(recurringInfo.nextDueDate).format('YYYY-MM-DD')
        return (nextDueDate == this.state.todayDate)
    }


    saveRecurringEmail(subject, toEmail, ccEmail, content, buttonLabel, status) {
        status = status || 'active'
        window.scrollTo(0, 0)
        this.setState({ loading: true })
        let data = {
            status: status,
        }
        const recurringInfo = this.state.proposal.quote.recurringInfo && this.state.proposal.quote.recurringInfo.attributes ? this.state.proposal.quote.recurringInfo.attributes : {}
        if (status === 'active' || !recurringInfo.emailSubject) {
            data.recurringInfo = {
                emailSubject: subject,
                emailAddresses: toEmail,
                emailCCAddresses: ccEmail,
                emailContent: content,
                emailButtonLabel: buttonLabel,
            }
        }

        AppContext.getApiClient().patch('/invoices/' + this.state.proposal.quote.id, data).then(res => {
            if (this.nextDueDateIsToday() && recurringInfo.createdInvoiceCount === 0) {
                data["proposalId"] = this.state.proposal.id
                this.activateAndCreateFirstRecurringInvoice(data)
            } else {
                this.setState({
                    loading: false,
                })
                if (res.id) {
                    this.setState({
                        redirect: <Redirect to={{
                            pathname: '/' + this.state.type + 's/' + res.id + '/edit',
                        }} />
                    })
                }
            }
        })
    }

    activateAndCreateFirstRecurringInvoice(data) {
        AppContext.getApiClient().post(`/invoices/${this.state.proposal.quote.id}/activate`, data).then(res => {
            const firstRecurringInvoice = res.attributes.recurringInfo.attributes.firstRecurringInvoice
            this.setState({
                editMode: false,
                loading: false,
            })
            if (res.id) {
                this.setState({
                    redirect: <Redirect to={{
                        pathname: '/' + this.state.type + 's/' + this.state.proposal.quote.id + '/edit',
                        state: { firstRecurringInvoice }
                    }} />
                })
            }
        })
    }

    markAsInactive(e) {
        e.preventDefault()
        const template = this.state.invoiceEmailTemplate ? this.state.invoiceEmailTemplate.attributes : {}
        this.saveRecurringEmail(template.subject, this.getCustomerEmailAddresses(), '', template.content, this.getDefaultButtonLabel(), 'inactive')
    }

    markAsActive(e) {
        e.preventDefault()
        const template = this.state.invoiceEmailTemplate ? this.state.invoiceEmailTemplate.attributes : {}
        this.saveRecurringEmail(template.subject, this.getCustomerEmailAddresses(), '', template.content, this.getDefaultButtonLabel(), 'active')
    }

    getDefaultButtonLabel() {
        return this.state.proposal.global.language.includes('fr') ? 'Ouvrir' : 'Open'
    }

    markAsSent(e) {
        e.preventDefault()
        this.sendProposal('', '', '', '', '', '', '', '', '', '')
    }

    configureRecurringEmail(event) {
        event.preventDefault()
        const recurringInfo = this.state.proposal.quote.recurringInfo && this.state.proposal.quote.recurringInfo.attributes ? this.state.proposal.quote.recurringInfo.attributes : {}
        const email = recurringInfo.emailAddresses ? recurringInfo.emailAddresses.split(',').map(a => a.toString().trim()) : this.getCustomerEmailAddresses()
        const ccEmail = recurringInfo.emailCCAddresses ? recurringInfo.emailCCAddresses.split(',').map(a => a.toString().trim()) : []
        const fromName = recurringInfo.fromName ? recurringInfo.fromName : this.state.proposal.attributes.variables.seller.name
        this.setState({
            modal: <SendEmailModal
                lastEmailSubject={recurringInfo.emailSubject}
                lastEmailContent={recurringInfo.emailContent}
                lastEmailButtonLabel={recurringInfo.emailButtonLabel}
                onSubmit={this.saveRecurringEmail}
                onClose={this.handleCloseModal}
                isCustomFromName={recurringInfo.emailFromName != ""}
                fromName={fromName}
                toEmail={email}
                ccEmail={ccEmail}
                proposalType={'invoice'}
                templateKey={'send-invoice'}
                isRecurringEmail={true}
                ctaLabel={<FormattedMessage
                    id="common.send_email.modal.activate_btn"
                    defaultMessage="Activate"
                />}
            />
        })
    }

    handleCloseModal() {
        this.setState({
            modal: ''
        }, this.refreshProposal())
    }

    getCustomerEmailAddresses() {
        return this.state.proposal.customer.email ?
            GlobalHelper.formatContactEmail(this.state.proposal.customer.email, this.state.proposal.customer.name) : ''
    }

    getTemplateType() {
        switch (this.state.type) {
            case 'invoice':
                return 'send-invoice'
            case 'quote':
                return 'send-proposal'
            case 'contract':
                return 'send-contract'
            case 'order':
                return 'send-order'
            case 'account-statement':
                return 'send-account-statement'
            case 'price-list':
                return 'new-order-from-price-list'
            case 'scheduling-page':
                return 'send-scheduling-page'
            default:
                return ''
        }
    }

    openSendEmail(event) {
        event.preventDefault()
        this.setState({
            modal: <SendEmailModal
                onSubmit={this.sendProposal}
                onClose={this.handleCloseModal}
                toEmail={this.getCustomerEmailAddresses()}
                fromName={this.state.proposal.seller.name}
                proposalType={this.state.type}
                templateKey={this.getTemplateType()}
            />
        })
    }

    openPreview(event) {
        event.preventDefault()
        this.setState({
            modal: <ProposalPreviewModal
                onClose={this.handleCloseModal}
                pdfLink={this.state.proposal.document.pdfUri}
                hash={this.state.hash}
                publicLink={this.state.publicLink}
                proposalType={this.state.type}
                onTabChange={(mobile) => {
                    this.setState({
                        mobile,
                    })
                }}
            />
        })
    }

    toggleToolbar(event) {
        event.preventDefault()
        this.setState({
            showToolbar: !this.state.showToolbar
        })
    }

    hasUndefinedItems() {
        const rows = this.state.proposal.quote.items || []
        const items = rows.filter(i => i.isUndefined === true)
        return items.length > 0
    }

    handleChangeTemplate(templateId) {
        return function (e) {
            e.preventDefault()
            this.setState({ templateLoading: true })
            AppContext.getApiClient().patch('/proposals/' + this.state.hash, {
                templateId: templateId,
            }).then(res => {
                this.refreshProposal(() => {
                    this.setState({
                        templateLoading: false,
                    })
                })
            })
        }.bind(this)
    }

    getCurrentTemplateName() {
        const template = this.state.templates.filter(t => t.id === this.state.templateId)
        if (template.length > 0) {
            return template[0].attributes.name
        } else {
            return ''
        }
    }

    activateButton(warnings) {
        const createdInvoiceCount = this.state.proposal.quote.recurringInfo.attributes.createdInvoiceCount
        if (this.state.status !== 'active' || (this.nextDueDateIsToday() && createdInvoiceCount === 0)) {
            if (this.nextDueDateIsToday() && createdInvoiceCount === 0) {
                return <ActionButton key={'activate-and-create'} disabled={warnings.length > 0} className="btn btn-success" onClick={this.markAsActive}>
                    <Icon value={"check"} className={"mr-1"} />
                    <FormattedMessage
                        id="quote.edit.preview.activate_and_create_btn"
                        defaultMessage="Activate and create first invoice"
                    />
                </ActionButton>
            }

            return <ActionButton key={'activate'} disabled={warnings.length > 0} className="btn btn-success" onClick={this.markAsActive}>
                <Icon value={"check"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.activate_btn"
                    defaultMessage="Activate"
                />
            </ActionButton>
        }

        return ""
    }

    isRecurringInvoice() {
        return this.state.proposal.quote.billingType === "recurring"
    }

    isReturn() {
        return this.state.proposal.quote.billingType === "return"
    }

    saveButtonsAreDisabled() {
        if (!this.isReturn()) {
            return parseFloat(this.state.proposal.quote.totalAmount) < 0
        }
        return parseFloat(this.state.proposal.quote.totalAmount) > 0
    }

    canSendRecurringEmail() {
        return this.state.proposal.quote.recurringInfo && this.state.proposal.quote.recurringInfo.attributes.sendEmail
    }

    stopLoading() {
        this.setState({
            moreLoading: false,
        })
    }

    printPdf(e) {
        const printUrl = this.state.proposalPrintUrl
        GlobalHelper.redirectToPrintPdf(printUrl)
        this.setState({
            moreLoading: false,
        })
    }

    activatePriceList(event) {
        event.preventDefault()
        AppContext.getApiClient().patch('/price-lists/' + this.state.proposal.quote.id, {
            emailSubject: this.state.priceListEmailTemplate.attributes.subject,
            emailContent: this.state.priceListEmailTemplate.attributes.content,
            emailButtonLabel: this.state.priceListEmailTemplate.attributes.buttonLabel,
        }).then(res => {
            return AppContext.getApiClient().post('/price-lists/' + this.state.proposal.quote.id + '/activate', {})
        }).then(res => {
            this.setState({
                loading: false,
                redirect: <Redirect to={'/price-lists/' + this.state.proposal.quote.id + '/edit'} />
            })
        })
    }

    saveEmailAndActivate(subject, toEmail, ccEmail, content, buttonLabel) {
        window.scrollTo(0, 0)
        this.setState({ loading: true })
        AppContext.getApiClient().patch('/price-lists/' + this.state.proposal.quote.id, {
            emailSubject: subject,
            emailContent: content,
            emailButtonLabel: buttonLabel,
        }).then(res => {
            return AppContext.getApiClient().post('/price-lists/' + this.state.proposal.quote.id + '/activate', {})
        }).then(res => {
            this.setState({
                loading: false,
                redirect: <Redirect to={'/price-lists/' + this.state.proposal.quote.id + '/edit'} />
            })
        })
    }

    getObjectId() {
        switch (this.state.type) {
            case 'scheduling-page': return this.state.proposal.schedulingPage.id
            default: return this.state.proposal.quote.id
        }
    }

    render() {
        if (!this.state.proposal || this.state.loading) {
            return <LoadingSpinner marginTop="20px" />
        }
        var showBranding = this.state.proposal.global.hasBranding
        const warnings = []
        if (this.hasUndefinedItems()) {
            warnings.push(<FormattedMessage
                id="quote.edit.preview.warnings.undefined_items"
                defaultMessage="Please define all items before sending the quote to the customer"
            />)
        }

        /* if (!this.state.proposal.customer.email && this.state.type !== 'price-list') {
            warnings.push(<FormattedMessage
                id="quote.edit.preview.warnings.email_missing"
                defaultMessage="Please define an email address to the customer before sending the quote"
            />)
        } */
        const actions = []

        if (this.state.editMode) {
            actions.push(<Link key={actions.length} className="btn btn-outline-secondary mr-2" to={'/' + this.state.type + 's/' + this.getObjectId() + '/edit'}>
                <Icon value={"times"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.close_edit_mode_btn"
                    defaultMessage="Close edit mode"
                />
            </Link>)
        }

        const allowedModalMessage = InvoiceHelper.GetOverCreditLimitMessagePermissionProceed(
            this.state.invoiceCurrency, this.state.owingBalance, this.state.invoiceBalance,
            this.state.creditLimit, true)

        const deniedModalMessage = InvoiceHelper.GetOverCreditLimitMessagePermissionProceed(
            this.state.invoiceCurrency, this.state.owingBalance, this.state.invoiceBalance,
            this.state.creditLimit, false)

        if (!this.isRecurringInvoice() && this.state.type !== 'price-list' &&
            this.state.proposal.quote.status === 'draft' && !this.isReturn()) {
            actions.push(<CreditLimitProtectionButton
                owingBalance={this.state.owingBalance}
                invoiceBalance={this.state.invoiceBalance}
                creditLimit={this.state.creditLimit}
                buttonClassName={"btn btn-outline-success mr-2"}
                onClickEventCallback={this.markAsSent}
                buttonIcon={<Icon value={"bullseye"} className={"mr-1"} />}
                buttonLabel={<FormattedMessage
                    id="invoice.edit.mark_as_done_btn"
                    defaultMessage="Mark as done"
                />}
                isDisabled={this.saveButtonsAreDisabled()}
                allowedModalMessage={allowedModalMessage}
                deniedModalMessage={deniedModalMessage}>
            </CreditLimitProtectionButton>
            )
        }

        if (this.isRecurringInvoice() && this.state.proposal.quote.status !== 'inactive') {
            actions.push(<ActionButton key={actions.length} className="btn btn-outline-primary mr-2" onClick={this.markAsInactive}>
                <Icon value={"toggle-off"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.mark_as_inactive_btn"
                    defaultMessage="Mark as inactive"
                />
            </ActionButton>)
        }

        if (this.isRecurringInvoice() && this.canSendRecurringEmail()) {
            actions.push(<button key={actions.length} disabled={warnings.length > 0} className="btn btn-success" onClick={this.configureRecurringEmail}>
                <Icon value={"envelope"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.configure_recurring_email_btn"
                    defaultMessage="Configure email"
                />
            </button>)
        }
        if (this.isRecurringInvoice() && !this.canSendRecurringEmail()) {
            actions.push(this.activateButton(warnings))
        }
        if (this.state.type === 'account-statement') {
            actions.push(<Link key={actions.length} className="btn btn-outline-dark mr-2" to={this.getRedirectUrl()}>
                <Icon value={"times"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.close_btn"
                    defaultMessage="Close"
                />
            </Link>)
            actions.push(<ActionButton key={actions.length} disabled={warnings.length > 0} className="btn btn-outline-primary mr-2" onClick={this.printPdf} isLoading={this.state.moreLoading}>
                <Icon value={"print"} className={"mr-1"} />
                <FormattedMessage
                    id="quote.edit.preview.print_btn"
                    defaultMessage="Print"
                />
            </ActionButton>)
        }

        if (!this.isRecurringInvoice() && !this.isReturn()) {
            let label = ''
            let buttonAction = this.openSendEmail
            let icon = "envelope"
            switch (this.state.type) {
                case 'invoice':
                    label = <FormattedMessage
                        id="quote.edit.preview.send_invoice_btn"
                        defaultMessage="Send invoice"
                    />
                    break
                case 'order':
                    label = <FormattedMessage
                        id="quote.edit.preview.send_order_btn"
                        defaultMessage="Send order"
                    />
                    break
                case 'stock-document':
                    label = <FormattedMessage
                        id="quote.edit.preview.send_stock-document_btn"
                        defaultMessage="Send {name}"
                        values={{
                            name: this.state.proposal.quote?.documentName ?? ""
                        }}
                    />
                    break
                case 'account-statement':
                    label = <FormattedMessage
                        id="quote.edit.preview.send_account_statement_btn"
                        defaultMessage="Send account statement"
                    />
                    break
                case 'price-list':
                    label = <FormattedMessage
                        id="quote.edit.preview.activate_price_list_btn"
                        defaultMessage="Activate"
                    />
                    buttonAction = this.activatePriceList
                    icon = "check"
                    break
                case 'contract':
                    label = <FormattedMessage
                        id="quote.edit.preview.send_contract_btn"
                        defaultMessage="Send contract"
                    />
                    break
                case 'scheduling-page':
                    label = <FormattedMessage
                        id="quote.edit.preview.send_scheduling_page_btn"
                        defaultMessage="Send scheduling page"
                    />
                    break
                case 'quote':
                default:
                    label = <FormattedMessage
                        id="quote.edit.preview.send_proposal_btn"
                        defaultMessage="Send proposal"
                    />
            }
            if (this.state.type === 'packing-slip') {
                actions.push(<ActionButton key={actions.length} disabled={warnings.length > 0} className="btn btn-primary" onClick={this.printPdf} isLoading={this.state.moreLoading}>
                    <Icon value={"print"} className={"mr-1"} />
                    <FormattedMessage
                        id="quote.edit.preview.print_btn"
                        defaultMessage="Print"
                    />
                </ActionButton>)
            } else {
                actions.push(<CreditLimitProtectionButton
                    owingBalance={this.state.owingBalance}
                    invoiceBalance={this.state.invoiceBalance}
                    creditLimit={this.state.creditLimit}
                    buttonClassName={"btn btn-success"}
                    onClickEventCallback={buttonAction}
                    buttonIcon={<Icon value={icon} className={"mr-1"} />}
                    buttonLabel={label}
                    isDisabled={this.saveButtonsAreDisabled()}
                    allowedModalMessage={allowedModalMessage}
                    deniedModalMessage={deniedModalMessage}>
                </CreditLimitProtectionButton>
                )
            }
        }


        return <div>
            {this.state.redirect}
            {this.state.modal}
            <div className={"row justify-content-center mb-5 pb-5"}>
                <div className={"col-lg-9 col-md-12 pl-5"}>
                    <ProposalContent
                        variables={this.state.proposal}
                        editable={true}
                        showBranding={showBranding}
                        onEdit={this.refreshProposal}
                        mobile={this.state.mobile}
                        isInsidePreview={true}
                        templateEmail={this.state.templateEmail} />
                </div>
            </div>
            <div className="row m-0 py-1 fixed-bottom pr-0 pr-md-5 pr-xl-0">
                <div className={'col-lg-12 mx-auto col-xl-11 pt-3 pl-4 pr-4 pr-md-5 pr-xl-4'}>
                    <div className="col-12 ui-module sticky-bottom-module">
                        <div className="row justify-content-end">
                            <div className="col-12 d-flex justify-content-between align-content-center" style={{ zIndex: 1021 }}>
                                <div className={""}>
                                    <Link className="btn btn-light mr-2" to={this.getRedirectUrl() + (this.state.editMode ? '?em=1' : '')}>
                                        <Icon value={"chevron-left"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.edit.preview.back_btn"
                                            defaultMessage="Back"
                                        />
                                    </Link>
                                    {this.state.templateLoading ?
                                        <button disabled={true} className={"btn btn-primary"}>
                                            <LoadingSpinner className={"px-4 mx-4"} height={20} />
                                        </button> :
                                        this.state.templates.length !== 0 && <div className="btn-group mr-2" role="group">
                                            <button id="btnGroupTemplate" type="button"
                                                className={"btn btn-outline-primary dropdown-toggle"} data-toggle="dropdown"
                                                aria-haspopup="true" aria-expanded="false">
                                                <Icon value={"book"} className={"mr-1"} />
                                                <FormattedMessage
                                                    id="quote.edit.preview.change_template_btn"
                                                    defaultMessage="Change template [{templateName}]"
                                                    values={{
                                                        templateName: this.getCurrentTemplateName(),
                                                    }}
                                                />
                                            </button>
                                            <div className="dropdown-menu" aria-labelledby="btnGroupTemplate">
                                                {this.state.templates.map(t => {
                                                    return <a key={t.id} className="dropdown-item" href="#" onClick={this.handleChangeTemplate(t.id)}>
                                                        {t.attributes.name}
                                                    </a>
                                                })}
                                            </div>
                                        </div>}
                                    <button className={"btn btn-primary"} onClick={this.openPreview}>
                                        <Icon value={"eye"} className={"mr-1"} />
                                        <FormattedMessage
                                            id="quote.edit.preview.preview_btn"
                                            defaultMessage="Preview"
                                        />
                                    </button>
                                </div>
                                {warnings.length > 0 ? <div className="text-right">
                                    {warnings.map((w, i) => {
                                        return <p key={i} className={'m-0'}>
                                            <i>{w}</i>
                                            &nbsp;
                                            <Icon value={"exclamation"} className={"text-danger"} />
                                        </p>
                                    })}
                                </div> : ''}
                                <div className={""}>
                                    {actions}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }

}

export default ProposalPreview





// WEBPACK FOOTER //
// ./src/proposal/preview.component.jsx